@if (defaultLogo) {
    <div
        [ngClass]="{
            'logo-container-header': context !== sectionLogo.footer,
            'logo-container-footer': context === sectionLogo.footer,
        }"
        class="logo-container justify-content-center"
    >
        <img
            alt="Facility Logo"
            [ngSrc]="defaultLogo"
            [width]="width"
            [height]="height"
            [style.width]="width"
            [style.max-width]="'100%'"
            [style.height]="height"
            [ngClass]="{
                'logo-header': context !== sectionLogo.footer,
                'logo-footer': context === sectionLogo.footer,
            }"
            class="logo"
            priority
        />
    </div>
}
